import React from "react"
import container from "inversify.config"
import type { ILanguageService } from "services/languageService"
import { TYPES } from "services/types"
import { Menu } from "components/base/Menu/Menu"
import { MenuItem } from "components/base/Menu/MenuItem/MenuItem"

const languageService = container.get<ILanguageService>(TYPES.ILanguageService)

const onUserClick = ({ key }: any) => {
  if (key === "thai") {
    languageService.setLanguage("th")
  } else {
    languageService.setLanguage("en")
  }
}

export const LanguageMenu = (): JSX.Element => {
  return (
    <Menu onClick={onUserClick}>
      <MenuItem key="thai">ไทย</MenuItem>
      <MenuItem key="english">English</MenuItem>
    </Menu>
  )
}
